﻿import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ITimeRange } from '../../src';
import * as _ from 'lodash';

@Component({
  selector: 'cl-time-range',
  templateUrl: './TimeRangeComponent.html'
})
export class TimeRangeComponent implements OnInit {
    SECONDS_IN_DAY = 24 * 60 * 60;
    static $name = 'clTimeRange';

    @Input() formGroup: FormGroup;
    @Input() interval: number;
    @Input() nullEnds: boolean;
    @Input() showTimepickerDialog: boolean;
    @Input() textAlertClass: string;
    @Input() timeRange: ITimeRange;

    ngOnInit() {
        this.initializeForm();
    }

    private initializeForm() {
        this.removePreviousControlIfExists();
        this.formGroup.addControl('timeRangeGroup', new FormGroup({}, [this.customTimeValidator()]));
    }

    private removePreviousControlIfExists() {
        this.formGroup.removeControl('timeRangeGroup');
    }

    private customTimeValidator() {
        return () => {
            const isTimeRangeSane = this.timeRange.start < (this.timeRange.end || this.SECONDS_IN_DAY);
            return isTimeRangeSane ? null : { saneTimeRange: true };
        };
    }
}
